<re-captcha
  class="captcha"
  [id]="id"
  [class.invisible-captcha]="isInvisibleRecaptcha"
  [siteKey]="to.recaptchaToken"
  (resolved)="onResolve($event)"
  (error)="onRecaptchaError()"
  [size]="to.recaptchaType"
></re-captcha>
